import { getInitState } from 'utils/async-middleware';
import { actionTypes } from 'common/actions/tags';

const initState = getInitState();

export const tagsReducer = (state = { ...initState }, action: any) => {
  switch (action.type) {
    case actionTypes.fetchTags: {
      const { type, ...restAction } = action;

      return {
        ...state,
        ...restAction,
      };
    }

    default:
      return state;
  }
};

export const tagReducer = (state = { ...initState }, action: any) => {
  switch (action.type) {
    case actionTypes.fetchTagById: {
      const { type, ...restAction } = action;

      return {
        ...state,
        ...restAction,
      };
    }

    default:
      return state;
  }
};
